var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0175 101.461C47.4082 101.461 51.7783 97.0905 51.7783 91.6998C51.7783 86.3091 47.4082 81.939 42.0175 81.939C36.6268 81.939 32.2567 86.3091 32.2567 91.6998C32.2567 97.0905 36.6268 101.461 42.0175 101.461Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8095 101.461C75.2002 101.461 79.5702 97.0905 79.5702 91.6998C79.5702 86.3091 75.2002 81.939 69.8095 81.939C64.4188 81.939 60.0487 86.3091 60.0487 91.6998C60.0487 97.0905 64.4188 101.461 69.8095 101.461Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.835 101.009C131.226 101.009 135.596 96.6387 135.596 91.248C135.596 85.8573 131.226 81.4872 125.835 81.4872C120.445 81.4872 116.075 85.8573 116.075 91.248C116.075 96.6387 120.445 101.009 125.835 101.009Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.723 93.4026C112.476 92.3901 112.343 91.3326 112.343 90.2445C112.343 82.9437 118.262 77.0253 125.563 77.0253C132.864 77.0253 138.783 82.9437 138.783 90.2445C138.783 91.4631 138.563 93.3126 138.254 94.4331L137.702 95.9937H151.193C151.531 95.8245 152.248 95.0604 152.41 93.3567C152.572 91.6521 152.748 80.0682 152.815 74.49L151.497 72.0555C152.207 71.6838 153.607 70.5336 153.526 68.9109C153.425 66.8823 150.787 51.0586 147.44 42.0309L155.7 41.4123C155.06 39.8914 152.05 36.8495 146.575 36.8495",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4474 78.8892H27.3992V94.9353H29.6039",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.705 84.3738H86.5549C85.8093 84.3738 85.2049 84.9782 85.2049 85.7238V95.7158C85.2049 96.4614 85.8093 97.0658 86.5549 97.0658H107.705C108.45 97.0658 109.055 96.4614 109.055 95.7158V85.7238C109.055 84.9782 108.45 84.3738 107.705 84.3738Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6703 80.9862H24.3V86.6391H26.6703",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.042 35.54C114.441 35.7091 134.093 36.0674 137.501 36.1486C139.651 36.1998 141.259 36.251 142.573 36.7591",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.487 36.85C146.169 32.6912 142.112 24.1824 137.804 23.2659C133.037 22.2515 120.764 21.0344 113.258 21.4401C110.214 20.2229 106.056 18.9043 103.824 18.6C102.37 30.4339 99.6651 58.5648 100.477 76.4169C105.548 76.8228 112.548 78.0405 117.112 79.1556",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.008 38.1768V73.2732C132.887 73.2732 140.187 76.0875 142.924 87.981H148.86V73.7799V70.9395C148.903 67.119 148.707 59.9922 147.874 53.1889",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M126.5 64.2255C128.285 64.9563 130.219 64.7331 130.963 64.5297",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.006 70.5345C133.95 69.4185 107.679 67.9983 103.216 68.1",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.45 55.1006L129.118 54.098C128.665 54.0435 128.325 53.6599 128.325 53.2044V41.4006C128.325 40.9035 128.728 40.5006 129.225 40.5006H136.183",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144.3 39.1242H139.725V60.1242H144.3V39.1242Z",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.cd68c357e69fe1822d11ac541177c36b.svg";
export { ForwardRef as ReactComponent };